import React, { useEffect, useState } from "react"
import axios from "axios";
import { AddUserButton, CreateButton } from "../components/Button";
import { CreateForm, FormInput, FormLabel, InlineInput, FormTextarea, ErrorMessage, SuccessMessage, RadioLabel, RadioInput } from "../components/Form";
import Chatbox from "./Chatbox";

const Form = ({
    returnFromSubmit = () => console.log('return'),
    cancelSubmit = () => console.log('back'),
    data,
}) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const id = urlSearchParams.get('t');

    const [record, setRecord] = useState({
        prompt: "",
        kata_client_id: Date.now(),
        client_name: "",
        whatsapp_number: "",
        user_data: [],
        intent: [],
        prompt_tag: "",
        username: "",
        password: "",
        fileupload: undefined,
        filename: "",
        expiry_date: 0,
        prompt_rephraser: '',
        embedding_type: 'azure'
    })

    const [error, setError] = useState(null);
    const [errorAccount, setErrorAccount] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    const parseFromJson = (json) => {
        return Object.keys(json).map(key => {
            const product = json[key];
            
            return {
                name: product,
                phone: key // Use the original key as a property
            };
        });
    }

    const addUser = () => {
        setRecord({
            ...record,
            user_data: [...record.user_data, {
                phone: "",
                name: ""
            }]
        })
    }

    const removeUser = (idx) => {
        setRecord({
            ...record,
            user_data: record.user_data.filter((item, index) => {
                return index !== idx
            })
        })
    }

    const handleChangeInput = (e) => {
        setRecord({
            ...record,
            [e.target.name]: e.target.value
        })
    }

    const handleChangeFileInput = (e, filename) => {
        if (e.target.files && e.target.files[0]) {
            setRecord({
                ...record,
                [e.target.name]: e.target.files[0],
                [filename]: e.target.files[0].name
            })
        }
    }

    const handleChangeInputUser = (e, idx) => {
        setRecord({
            ...record,
            user_data: record.user_data.map((item, index) => index === idx ? {
                ...item,
                [e.target.name]: e.target.value
            } : item)
        })
    }

    const getConfigCreateOrUpdate = () => {
        let data = JSON.stringify({
            "kata_client_id": record.kata_client_id,
            "prompt": record.prompt,
            "user_data": JSON.stringify(transform(record.user_data)),
            "whatsapp_number": record.whatsapp_number,
            "client_name": record.client_name,
            "promp_tag": record.prompt_tag,
            "prompt_rephraser": record.prompt_rephraser,
            "product_data": record.product_data && transformProduct(record.product_data) !== "" 
                ? 
                JSON.stringify(transformProduct(record.product_data)) : "",
        });
        if (record.prompt_rephraser === "" || record.prompt_rephraser === null) {
            data = JSON.stringify({
                "kata_client_id": record.kata_client_id,
                "prompt": record.prompt,
                "user_data": JSON.stringify(transform(record.user_data)),
                "whatsapp_number": record.whatsapp_number,
                "client_name": record.client_name,
                "promp_tag": record.prompt_tag,
                "product_data": record.product_data && transformProduct(record.product_data) !== "" 
                    ? 
                    JSON.stringify(transformProduct(record.product_data)) : "",
            });
        }

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: process.env.REACT_APP_BASE_URL,
            headers: { 
              'Content-Type': 'application/json'
            },
            data : data
        };

        if (record._id) {
            config = {
                method: 'put',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_BASE_URL}${record._id}`,
                headers: { 
                  'Content-Type': 'application/json'
                },
                data : data
            };
        }

        return config;
    }

    const getConfigUploadFile = (id) => {
        let formData = new FormData();
        formData.append("file", record.fileupload);

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_CHROMA_URL}/submit/${id}?embedding_type=${record.embedding_type}`,
            headers: { 
                "Content-Type": "multipart/form-data" 
            },
            data : formData
        };

        return config;
    }

    const getConfigCredentials = (kataClientId) => {
        let method = "POST";
        let url = process.env.REACT_APP_AUTH_REGISTER;

        let credentialLogin = JSON.stringify({
            "username": record.username,
            "password": record.password,
            "kata_client_id": kataClientId,
            "expiry_date": Number(record.expiry_date)
        });

        if (record._id) {
            method = "PUT";
            url = `${process.env.REACT_APP_BASE_URL}user/${record._id}`;
        }

        let config = {
            method,
            maxBodyLength: Infinity,
            url,
            headers: { 
                'Content-Type': 'application/json'
            },
            data : credentialLogin
        };

        return config;
    }

    const getConfigIntent = (kataClientId) => {
        let intent = JSON.stringify({
            "kata_client_id": kataClientId,
            "intent_classes": JSON.stringify(transformIntent(record.intent)),
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: process.env.REACT_APP_INTENT_URL,
            headers: { 
                'Content-Type': 'application/json'
            },
            data : intent
        };

        return config;
    }

    const submit = async (e) => {
        e.preventDefault();
        setError(null);
        setErrorAccount(null);
        setLoading(true);

        try {
            const config = getConfigCreateOrUpdate();
            const resCreateOrUpdate = await axios.request(config);

            setRecord({
                ...record,
                ...resCreateOrUpdate.data,
                _id: resCreateOrUpdate.data._id,
                product_data: resCreateOrUpdate.data.product_data !== "" ? parseFromJson(JSON.parse(resCreateOrUpdate.data.product_data)) : [],
                user_data: resCreateOrUpdate.data.user_data !== "" ? parseFromJson(JSON.parse(resCreateOrUpdate.data.user_data)) : [],
            });

            if (record.fileupload) {
                const configUpload = getConfigUploadFile(resCreateOrUpdate.data._id);
                await axios.request(configUpload);
            }

            if (record.username !== "" && record.password !== "" && record.expiry_date > 0) {
                const configCredentials = getConfigCredentials(resCreateOrUpdate.data.kata_client_id);
                await axios.request(configCredentials);
            }

            if (record.intent && record.intent.length > 0) {
                const configIntent = getConfigIntent(resCreateOrUpdate.data.kata_client_id);
                await axios.request(configIntent);
            }


            if (record._id) {
                setShowSuccess(true);
            } else {
                returnFromSubmit()
            }
        } catch (error) {
            processError(error);
        } finally {
            setLoading(false)
        }
    }

    const processError = (error) => {
        if (error.response && error.response.data) {
            if (error.response.data.detail) {
                setError(error.response.data.detail)
            } else if (error.response.data.message) {
                setError(error.response.data.message)
            } else {
                setError(error.response.data)
            }
        } else {
            setError(error.message);
        }
    }

    const deleteFile = async () => {
        try {
            let data = JSON.stringify({
                "filename": record.filename
              });
              
              let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_CHROMA_URL}/delete?prompt_id=${record._id}`,
                headers: { 
                  'Content-Type': 'application/json'
                },
                data : data
              };

              await axios.request(config);

              setRecord({
                  ...record,
                  fileupload: undefined,
                  filename: ""
              })
        } catch (error) {
            setError(error.message);
        } 
    }

    const transform = (array) => {
        const transformedObject = {};
    
        array.forEach(item => {
            transformedObject[item.phone] = item.name;
        });

        return transformedObject;
    }

    const transformIntent = (array) => {
        const transformedObject = {};
    
        array.forEach(item => {
            transformedObject[item.name] = item.text;
        });

        return transformedObject;
    }

    const transformProduct = (array) => {
        if (array.length > 0) {
            const transformedObject = {};
        
            array.forEach(item => {
                transformedObject[item.key] = { ...item.value };
            });
    
            return transformedObject;
        }

        return "";
    }

    useEffect(() => {
        if (data && data !== null) {
            setRecord({
                ...data,
                user_data: data.user_data ? data.user_data.map((item) => ({
                    phone: item.key,
                    name: item.value
                })) : []
            })
        }
    }, [data])

    return (
        <InlineInput>
            <CreateForm onSubmit={submit}>
                {showSuccess && <SuccessMessage>Saved Success</SuccessMessage>}
                {error && <ErrorMessage>{error}</ErrorMessage>}
                <FormLabel>Kata Client ID</FormLabel>
                <FormInput 
                    type="hidden" 
                    name="kata_client_id" 
                    placeholder="Enter client id" 
                    readOnly={true}
                    value={record.kata_client_id ? record.kata_client_id : ''}
                    onChange={(e) => handleChangeInput(e)}
                />
                <FormInput 
                    type="text" 
                    placeholder="Enter client id" 
                    disabled
                    value={record.kata_client_id ? record.kata_client_id : ''}
                />

                <FormLabel>Client Name</FormLabel>
                <FormInput 
                    type="text" 
                    name="client_name" 
                    placeholder="Enter client name" 
                    required 
                    value={record.client_name ? record.client_name : ''}
                    onChange={(e) => handleChangeInput(e)}
                />

                <FormLabel>Bot Whatsapp Number <i><small>(optional, for information purpose only)</small></i></FormLabel>
                <FormInput 
                    type="text" 
                    name="whatsapp_number" 
                    placeholder="Enter whatsapp number" 
                    value={record.whatsapp_number ? record.whatsapp_number : ''}
                    onChange={(e) => handleChangeInput(e)}
                />

                <FormLabel>Prompt</FormLabel>
                <FormTextarea
                    rows="10"
                    placeholder="Enter prompt"
                    name="prompt"
                    required
                    value={record.prompt ? record.prompt : ''}
                    onChange={(e) => handleChangeInput(e)}
                />

                <FormLabel>Prompt Rephraser</FormLabel>
                <FormTextarea
                    rows="10"
                    placeholder="Enter prompt rephraser"
                    name="prompt_rephraser"
                    value={record.prompt_rephraser ? record.prompt_rephraser : ''}
                    onChange={(e) => handleChangeInput(e)}
                />

                <FormLabel>Login credentials {record._id && <i><small>(Fill password if u want to update credentials)</small></i>}</FormLabel>
                {errorAccount && <ErrorMessage>{errorAccount}</ErrorMessage>}
                <InlineInput>
                    <FormInput 
                        type="text" 
                        name="username" 
                        placeholder="Enter username" 
                        value={record.username ? record.username : ''}
                        onChange={(e) => handleChangeInput(e)}
                    />
                    <FormInput 
                        type="password" 
                        name="password" 
                        placeholder="Enter password" 
                        value={record.password ? record.password : ''}
                        onChange={(e) => handleChangeInput(e)}
                    />
                </InlineInput>
                <FormLabel>Expiration day of login</FormLabel>
                <FormInput 
                    type="number" 
                    name="expiry_date" 
                    placeholder="Enter expired date" 
                    value={record.expiry_date ? record.expiry_date : 0}
                    onChange={(e) => handleChangeInput(e)}
                />

                <InlineInput>
                    <FormLabel>Whitelist <i><small>(It's optional, but if it's for WhatsApp, you must request their phone number and name.)</small></i></FormLabel>
                    <AddUserButton type="button" onClick={() => addUser()}>Add Whitelist</AddUserButton>
                </InlineInput>
                {record.user_data && record.user_data.length > 0 &&
                    record.user_data.map((item, index) => (
                        <InlineInput
                            key={index}
                        >
                            <FormInput 
                                type="text" 
                                placeholder="Phone number" 
                                required 
                                value={item.phone} 
                                name="phone"
                                onChange={(e) => handleChangeInputUser(e, index)}
                            />
                            <FormInput 
                                type="text" 
                                placeholder="Name" 
                                required
                                name="name"
                                value={item.name} 
                                onChange={(e) => handleChangeInputUser(e, index)}
                            />
                            <AddUserButton type="button" variant="#d94115" onClick={() => removeUser(index)}>Remove</AddUserButton>
                        </InlineInput>
                    ))
                }

                <FormLabel>File Upload <i><small>(You can upload TXT, CSV or PDF files to boost our chatbot's knowledge! 📚✨)</small></i></FormLabel>

                <InlineInput>
                    <RadioLabel>
                        <RadioInput
                            type="radio"
                            name="embedding_type"
                            checked={record.embedding_type === "azure"}
                            onChange={(e) => 
                                setRecord({
                                    ...record,
                                    embedding_type: "azure"
                                })
                            }
                        />
                        OpenAI
                    </RadioLabel>
                    <RadioLabel>
                        <RadioInput
                            type="radio"
                            name="embedding_type"
                            checked={record.embedding_type === "vertex"}
                            onChange={(e) => 
                                setRecord({
                                    ...record,
                                    embedding_type: "vertex"
                                })
                            }
                        />
                        VertexAI
                    </RadioLabel>
                </InlineInput>

                {record.fileupload && record.filename && record.filename !== "" ? 
                    <InlineInput>
                        <FormInput 
                            type="text" 
                            placeholder="Phone number" 
                            disabled 
                            value={record.filename} 
                            name="phone"
                        />
                        <AddUserButton type="button" variant="#d94115" onClick={() => deleteFile()}>Remove</AddUserButton>
                    </InlineInput>
                    :
                    <FormInput 
                        type="file" 
                        name="fileupload" 
                        placeholder="Choose file" 
                        accept=".txt, .pdf, .csv"
                        value={record.fileupload ? record.fileupload : ''}
                        onChange={(e) => {
                            handleChangeFileInput(e, 'filename');
                        }}
                    />
                }

                <CreateButton variant="gray" type="button" onClick={() => cancelSubmit()}>Cancel</CreateButton>
                <CreateButton type="submit" disabled={loading}>Save</CreateButton>
            </CreateForm>
            {record._id && id &&
                <Chatbox options={record.user_data.length > 0 ? record.user_data.map((item) => ({
                    label: `(${item.phone}) ${item.name}`,
                    value: item.phone
                })) : []} data={record} />
            }
        </InlineInput>
    )
}

export default Form;
